var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"tel:+41 44 515 52 55"}},[_vm._v("+41 44 515 52 55")])}
var staticRenderFns = []

export { render, staticRenderFns }